import { http } from '@/http';
import { RecurrenteProduct } from '@/entities/payment';

export const getPaymentProducts = () =>
  http.get<RecurrenteProduct[]>('v1/payments/products');
